<template>
  <div class="treeINtnents">
    <div class="conent_werp">
      <!-- 树形图 -->
      <div
        ref="left"
        class="left"
        :style="{
          backgroundColor: '#e2ebf1',
          width: treeHidder == true ? '10px' : '',
        }"
        v-if="roletype != 2"
      >
        <listTree
          class="treePostiron"
          ref="trueeEl"
          @chuindScllor="chuindScllor"
          :treedata="treeData"
          @trreList="trreList"
          @serchBten="serchBten"
          :dataobjs-send="dataobjsSend"
          :keystree="keystree"
          @countClickTree="countClickTree"
          :tree-hidder="treeHidder"
          :style="{ width: treeHidder == true ? 0 : '' }"
        />
        <div class="newimgList_Warp" @click="isShowFly">
          <img src="@/assets/img/xiaz.png" alt />
        </div>
      </div>
      <div class="ceonetns">
        <div class="ovst">
          <div class="heneds">
            <el-card
              class="box-card"
              style="
                padding: 2px 20px;
                position: fixed;
                width: 94.5%;
                background: #ffffff;
                z-index: 11;
              "
            >
              <div class="flexn" style="display: flex">
                <el-button type="primary" size="mini" @click="zheclick">
                  {{ dataobjsSend.quanbuzhedie }}
                </el-button>
                <el-button type="primary" size="mini" @click="myClick">
                  {{ dataobjsSend.quanbuzhankai }}
                </el-button>
                <!-- <el-button type="primary" size="mini" @click="myFengTuClick">
                    {{titeltData}}

                </el-button>-->
                <el-dropdown
                  size="mini"
                  split-button
                  type="primary"
                  style="padding: 0 5px"
                  @command="myFengTuClick"
                >
                  {{ titeltData }}
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">
                      {{ dataobjsSend.datubiao }}
                    </el-dropdown-item>
                    <el-dropdown-item command="2">
                      {{ dataobjsSend.zhongtubiao }}
                    </el-dropdown-item>
                    <el-dropdown-item command="3">
                      {{ dataobjsSend.xiaotubiao }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-button type="primary" size="mini" @click="myFengTuClickAll">{{
                  dataobjsSend.quanbushuaxin
                }}</el-button>

                <!-- <el-button type="danger" size="mini" @click="myCLOnwe">清空全部</el-button> -->
                <!-- optionsChiiend<1 && -->
                <div v-if="optionsChiiend.length > 1">
                  <span style="margin: 0 3px; display: inline-flex">
                    {{ dataobjsSend.qingxuanze }}
                  </span>
                  <el-select
                    v-model="valueUiid"
                    placeholder="请选择区域"
                    @change="mychange"
                    style="height: 20px"
                  >
                    <el-option :key="0" label="全部" :value="0"></el-option>
                    <el-option
                      v-for="item in optionsChiiend"
                      :key="item.uuid"
                      :label="item.areaname"
                      :value="item.uuid"
                    ></el-option>
                  </el-select>
                </div>
                <div style="padding: 0 20px" v-if="selectTabFe">
                  <span style="margin: 0 3px; display: inline-flex">
                    {{ dataobjsSend.xuanzeyema }}
                  </span>
                  <el-select
                    v-model="countLint"
                    placeholder="请选择页面"
                    @change="mychangeCount"
                    style="height: 20px; width: 80px"
                  >
                    <el-option
                      v-for="item in countListName"
                      :key="item.id"
                      :label="item.lableL"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="netColor" style="padding-left: 20px">
                  <div class="colorEnd"></div>
                  <div style="padding: 0px 5px">{{ dataobjsSend.gaoyushangxian }}</div>
                </div>
                <div class="netColor">
                  <div class="colorEnd" style="background: #47b5fb"></div>
                  <div style="padding: 0px 5px">{{ dataobjsSend.diyuxiaxian }}</div>
                </div>
                <div class="netColor">
                  <div class="colorEnd" style="background: #22e2b1"></div>
                  <div style="padding: 0px 5px">{{ dataobjsSend.zhengchang }}</div>
                </div>
                <div class="netColor">
                  <div class="colorEnd" style="background: #b56742"></div>
                  <div style="padding: 0px 5px">{{ dataobjsSend.canshuguzhang }}</div>
                </div>
                <div class="netColor">
                  <div>{{ dataobjsSend.kaiqizidongshuaxin }}</div>
                  <div style="padding: 0px 5px">
                    <el-switch
                      v-model="tiemFnet"
                      :active-text="dataobjsSend.shi"
                      :inactive-text="dataobjsSend.fou"
                      @change="guanbiTab"
                    ></el-switch>
                  </div>
                </div>
                <div class="netColor">
                  <div style="color: #409eff">
                    {{ timesINte }}{{ dataobjsSend.miaohoushuaxin }}
                  </div>
                </div>
              </div>
            </el-card>
            <div style="padding: 20px 0"></div>
            <!-- 折叠面板 -->

            <div
              class="zhe"
              v-loading="Delectloading"
              :element-loading-text="textContent"
              v-for="(item, index) in gatewaylistZhe"
              :key="item.uuid"
            >
              <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item :name="item.uuid">
                  <template slot="title">
                    <div class="titles">
                      <div class="leeft">
                        <div class="nelIGmgs">
                          <img
                            :src="
                              item.state == 1
                                ? zhenchangtupian
                                : item.state == 2
                                ? baojing
                                : lixiantupian
                            "
                            alt
                          />
                        </div>
                        <!-- 当是超级管理员 -->
                        <div style="color: rgb(255, 255, 255)" v-if="roletype == 0">
                          {{ item.dealername }}/{{ item.customername
                          }}{{ flyaThat == 1 ? "/" + item.areaname : "" }}/{{ item.name }}
                        </div>
                        <!-- 是客户 -->
                        <div style="color: rgb(255, 255, 255)" v-if="roletype == 2">
                          {{ flyaThat == 1 ? item.areaname + "/" : "" }}{{ item.name }}
                        </div>
                        <!-- 经销商 -->
                        <div style="color: rgb(255, 255, 255)" v-if="roletype == 1">
                          {{ item.customername
                          }}{{ flyaThat == 1 ? "/" + item.areaname : "" }}/{{ item.name }}
                        </div>
                        <!--  -->
                        <div style="padding: 0 20px; color: #fff">
                          {{ dataobjsSend.caijijiange }}:{{ item.uploadtime
                          }}{{ dataobjsSend.fenzhong }}
                        </div>
                        <div style="padding: 0 20px; color: #fff">
                          {{ dataobjsSend.gengxinshijian }}:
                          {{ item.collecttime }}
                        </div>
                        <div
                          v-if="item.state != 0"
                          style="
                            padding: 0 6px;
                            color: #fff;
                            display: flex;
                            align-items: center;
                          "
                          @click="tableListZhaoce(item)"
                        >
                          <!-- <img src="@/assets/img/WiFi.png" class="newWifx" alt /> -->

                          <el-button size="mini">
                            {{ dataobjsSend.zhaoceshuju }}
                          </el-button>
                        </div>
                        <div
                          style="color: #fff; display: flex; align-items: center"
                          @click="newLIne(item)"
                        >
                          <el-button size="mini" type="success" plain>
                            {{ dataobjsSend.chakanxiangqing }}
                          </el-button>
                        </div>
                        <div
                          style="
                            color: #fff;
                            display: flex;
                            align-items: center;
                            margin: 0 0px 0 5px;
                          "
                          @click="listn(item)"
                          class="pintesLnent"
                        >
                          <!-- <el-button size="mini" type="success" plain>{{
                            item.iconTile == undefined
                              ? titeltData
                              : item.iconTile
                          }}</el-button>-->
                          <el-dropdown
                            size="mini"
                            split-button
                            type="success"
                            style="padding: 0 5px"
                            @command="newLIneIcon"
                          >
                            {{ item.iconTile == undefined ? titeltData : item.iconTile }}
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item
                                :command="beforeHandleCommand(item, index, '1')"
                                >{{ dataobjsSend.datubiao }}</el-dropdown-item
                              >
                              <el-dropdown-item
                                :command="beforeHandleCommand(item, index, '2')"
                              >
                                {{ dataobjsSend.zhongtubiao }}
                              </el-dropdown-item>
                              <el-dropdown-item
                                :command="beforeHandleCommand(item, index, '3')"
                                >{{ dataobjsSend.xiaotubiao }}</el-dropdown-item
                              >
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                        <div
                          style="
                            color: #fff;
                            display: flex;
                            align-items: center;
                            margin: 0 5px;
                          "
                          class="pintesLnent"
                          @click="newLIneIconShuaxin(item, index)"
                        >
                          <el-button
                            size="mini"
                            type="success"
                            plain
                            style="width: 60px"
                            >{{ dataobjsSend.shuaxin }}</el-button
                          >
                        </div>
                        <div
                          v-if="item.ismonitor == 1"
                          style="
                            color: #fff;
                            display: flex;
                            align-items: center;
                            margin: 0 5px;
                          "
                          class="pintesLnent"
                          @click="CamerastHand(item, index)"
                        >
                          <el-button
                            size="mini"
                            type="success"
                            plain
                            style="width: 60px"
                            >{{ dataobjsSend.shexiangtou }}</el-button
                          >
                        </div>
                        <!--   -->
                        <!-- 控制 -->
                        <div
                          style="
                            color: #fff;
                            display: flex;
                            align-items: center;
                            margin: 0 5px;
                          "
                          v-if="item.relaycount != 0"
                          class="pintesLnent"
                          @click="confIngHnad(item, index)"
                        >
                          <el-button size="mini" type="success" plain style="width: 60px"
                            >控制</el-button
                          >
                        </div>
                      </div>
                      <div class="listRight">
                        {{
                          item.state == 0
                            ? dataobjsSend.lixian
                            : item.state == 1
                            ? dataobjsSend.zaixian
                            : dataobjsSend.baojing
                        }}
                      </div>
                      <!-- <div class=""></div> -->
                      <!-- <div class="fb" style="position: absolute;right: 5%;" @click="cloneDelect(index)">
                    <i class="el-icon-close" style="margin: 5px 0;"></i>
                      </div>-->
                    </div>
                  </template>
                  <!-- {{item.data}} -->
                  <!-- <div class="warp" v-if="true">
                  <div
                    :style="{width:item.flyus==true?'13%':''}"
                    v-for="(itemData) in item.data.channelinfo"
                    class="wd"
                    :key="itemData.channelid"
                  >
                    <div
                      :style="{ height:item.flyus == true? '100px': '79px'}"
                      :class="itemData.channelflag == 0 ? 'greed':itemData.channelflag == 1 ? 'bult' :'red' "
                    >
                      <div
                        v-if="itemData.channelname != ''"
                        class="titlesImgs"
                      >{{itemData.channelname}}</div>
                      <div
                        v-else
                        class="titlesImgs"
                      >{{ lang_file == 'zh-cn'? itemData.unittype:itemData.unittype_en}}</div>
                  <!-- <div>12℃</div>-->
                  <!-- <div
                        class="font-Sis"
                        :style="{fontSize:item.flyus==true?'40px':'',height:item.flyus==true?'51%':''}"
                      >{{itemData.channeldata}}</div>

                      <div class="boax_warp">
                        <div class="warp_left">{{itemData.remark}}</div>
                        <div class="warp_rigth">{{itemData.unit}}</div>
                      </div>
                    </div>
                  </div>
                  </div>-->

                  <!-- 折叠面板的图  v-else-->

                  <div class="warp">
                    <div
                      :style="{
                        width: item.flyus == 1 ? '17%' : item.flyus == 2 ? '13%' : '',
                      }"
                      v-for="itemData in item.data.channelinfo"
                      :class="'wd'"
                      :key="itemData.channelid"
                    >
                      <!-- <h1>{{temData.channelflag}}</h1> -->
                      <div
                        :class="
                          itemData.channelflag == 0
                            ? 'greed'
                            : itemData.channelflag == 1
                            ? 'bult'
                            : itemData.channelflag == 3
                            ? 'geeds'
                            : 'red'
                        "
                        :style="{
                          height:
                            item.flyus == 1
                              ? '120px'
                              : item.flyus == 2
                              ? '100px'
                              : '79px',
                        }"
                      >
                        <div v-if="itemData.channelname != ''" class="titlesImgs">
                          <!--修改图标 -->
                          <div class="rightIcom">
                            <i class="el-icon-edit" @click="iconHand(itemData)"></i>
                          </div>
                          <div :class="item.flyus == 1 ? 'fletnFedn' : 'fleCt'">
                            <img
                              :style="{
                                width: item.flyus == 1 ? '50px' : '30px',
                              }"
                              :src="itemData.icon"
                              alt
                            />
                          </div>
                          <div>{{ itemData.channelname }}</div>
                        </div>
                        <div v-else class="titlesImgs">
                          <!-- 修改图标 -->
                          <div class="rightIcom">
                            <i class="el-icon-edit" @click="iconHand(itemData)"></i>
                          </div>
                          <div :class="item.flyus == 1 ? 'fletnFedn' : 'fleCt'">
                            <img
                              :style="{
                                width: item.flyus == 1 ? '50px' : '30px',
                              }"
                              :src="itemData.icon"
                              alt
                            />
                          </div>
                          <div>
                            {{
                              lang_file == "zh-cn"
                                ? itemData.unittype
                                : itemData.unittype_en
                            }}
                          </div>
                        </div>
                        <!-- <div>12℃</div> -->
                        <div
                          class="font-Sis"
                          :style="{
                            fontSize:
                              item.flyus == 1 ? '45px' : item.flyus == 2 ? '36px' : '',
                            height:
                              item.flyus == 1 ? '51%' : item.flyus == 2 ? '51%' : '',
                          }"
                        >
                          {{ itemData.channeldata }}
                        </div>

                        <div class="boax_warp">
                          <div class="warp_left">{{ itemData.remark }}</div>
                          <div class="warp_rigth">
                            {{ lang_file == "zh-cn" ? itemData.unit : itemData.unit_en }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 折线图数据 -->
    <el-dialog
      :title="titleChinedListNameDoile"
      :visible.sync="dialogVisible"
      width="98%"
      :modal="false"
      class="netListDatal"
      :fullscreen="true"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <!--     -->
      <zhe_line
        @setClick="setClick"
        :titlenew="dataObjsZlk"
        :fly-chend="flyChend"
        @mantClick="mantClick"
        :delect-data="delectData"
        :addressphoto="addressphoto"
        :table-data="tableData"
        :data-x="dataX"
        :dataobjs-send="dataobjsSend"
        ref="dataLine"
        :data-mix="dataMix"
        :collecttime="collecttime"
        :conetn-cunt="conetnCunt"
        :channelid="channelidTitle"
        :cheid-fengxiang="cheidFengxiang"
        :channelid-list="channelidList"
        :teab="teab"
        :value1="value1"
        :dateset="dateset"
        :shshi-data="shshiData"
        @dayTime="dayTime"
        @channelidfunt="channelidfunt"
        @confingClick="confingClick"
        @lishData="lishData"
        @myFileupData="myFileupData"
        :title-obj="titleObj"
        :total="total"
        :page-data="pageData"
        :table-list="tableList"
        :lowerlimit="lowerlimit"
        :lowrlimt="lowrlimt"
      />
    </el-dialog>

    <!-- 实时数据弹框 -->
    <el-dialog
      :title="flyTitleName"
      :visible.sync="dialogVisibleDataOf"
      :modal="false"
      :fullscreen="true"
      width="95%"
    >
      <!-- 实时数据 -->
      <tableDataOf :table-datainfo="tableData" v-if="fly == '实时数据'" />
      <!-- 历史数据 -->
      <liData
        :cheid-fengxiang="cheidFengxiang"
        :channelid-list="channelidList"
        v-if="fly == '历史数据'"
        :conetn-cunt="conetnCunt"
        @setClick="setClick"
        @mantClick="mantClick"
        :total="total"
        @dayTime="dayTime"
        @confingClick="confingClick"
        :dateset="dateset"
        :value1="value1"
        :page-data="pageData"
        :table-list="tableList"
        @myFileupData="myFileupData"
      />
      <!-- 数据曲线 -->
      <data_line
        v-if="fly == '数据曲线'"
        :dateset="dateset"
        :data-x="dataX"
        :fly-chend="flyChend"
        :collecttime="collecttime"
        :channelid="channelidTitle"
        :title-obj="titleObj"
        :titlenew="dataObjsZlk"
        :teab="teablet"
        @confingClick="confingClick"
        :data-mix="dataMix"
        @dayTime="dayTime"
        :value1="value1"
        ref="datalineList"
        :lowerlimit="lowerlimit"
        :lowrlimt="lowrlimt"
        @channelidfuntEnd="channelidfuntEnd"
      />

      <mapDlist v-if="fly == '地图'" style="width: 100%; height: 500px"></mapDlist>
      <newImge v-if="fly == '现场显示'" :addressphoto="addressphoto" />
    </el-dialog>

    <!--修改上下限 -->
    <el-dialog
      :title="Dodata.xiugai"
      :visible.sync="dialogVisiblemssage"
      width="40%"
      :modal="false"
      center
    >
      <el-form
        label-position="right"
        label-width="90px"
        :model="formLabelAlign"
        class="formData"
      >
        <el-form-item :label="Dodata.tongdaobieming">
          <el-input v-model="formLabelAlign.channelname"></el-input>
        </el-form-item>
        <el-form-item :label="Dodata.shangxianzhi">
          <el-input v-model="formLabelAlign.upperlimit"></el-input>
        </el-form-item>
        <el-form-item :label="Dodata.xiaxianzhi">
          <el-input v-model="formLabelAlign.lowerlimit"></el-input>
        </el-form-item>
        <el-form-item :label="Dodata.shangxianbaojingzhi">
          <el-input v-model="formLabelAlign.upperlimit_alarm"></el-input>
        </el-form-item>
        <el-form-item :label="Dodata.xiaxianbaojingzhi">
          <el-input v-model="formLabelAlign.lowerlimit_alarm"></el-input>
        </el-form-item>
        <el-form-item :label="Dodata.beizhu">
          <el-input v-model="formLabelAlign.remark"></el-input>
        </el-form-item>
      </el-form>
      <div class="btenEtiel">
        <span slot="footer" class="dialog-footer addcentent">
          <el-button @click="dialogVisiblemssage = false">
            {{ Dodata.quxiao }}
          </el-button>
          <el-button type="primary" @click="dialogVisiblemssageAdd">
            {{ Dodata.queding }}
          </el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 倒计时弹框 -->
    <el-dialog
      title="召测数据"
      :close-on-click-modal="false"
      :visible.sync="Successdialog"
      :show-close="false"
      :close-on-press-escape="false"
      width="30%"
      center
    >
      <div class="doap_warp">
        正在召测数据，请稍候
        <span style="color: red; font-size: 22px">{{ pingName }} 秒</span>
      </div>
    </el-dialog>
    <!-- 摄像头 -->
    <el-dialog
      title="摄像头"
      :visible.sync="dialogVisibleDataOfCameraset"
      :modal="false"
      :fullscreen="true"
      width="95%"
      :before-close="handleCloseceamed"
    >
      <CameraSetings :getvalue="getvalue" />
    </el-dialog>
    <!-- 控制界面 -->
    <el-dialog
      :title="titleChinedListNameDoile + '(用电设备控制)'"
      :visible.sync="dialogVisibleDataOfSetconft"
      :modal="false"
      :fullscreen="true"
      width="95%"
    >
      <control
        :info-table-list="infoTableList"
        :getwayuuid="get_way_uuid"
        :falytable="orderInfoFaly"
        :get-title="titleChinedListNameDoile"
      />
    </el-dialog>
    {{ handPath }}
  </div>
</template>

<script>
import { getCode, getToken } from "@/network/authentication";
import md5 from "js-md5";
import Header from "@/components/common/header";
import listTree from "@/components/common/listTree";
import mapDlist from "./components/mapDlist";
import control from "./components/control";
import {
  treeinfo,
  getdata,
  AlistInfo,
  AlistShi,
  getdataCnhannel,
  checcenDN,
  getdataAreaH,
  dataInfoName,
  homeGetUidIn,
  updataList,
  lang_fend,
  imgUpdataXchang,
  getdataAreaHtse,
  getdataAreaSelect,
  dealerDelete,
  updataShang,
} from "@/network/index";
import zhe_line from "./components/zhe_line";
import { getdataChannelData, seetHandDatas } from "@/network/lineRequest";
import timeConvert from "../../components/common/newTimes";
import tableDataOf from "./components/tableDataOf";
import liData from "./components/liData";
import data_line from "./components/data_line";
import newImge from "./components/newImge";
import CameraSetings from "./components/CameraSetings";
import { swart, baojing, zhenchangtupian, lixiantupian } from "@/network/baserURL";

import { mapState } from "vuex";
import { setTimeout } from "timers";

export default {
  components: {
    listTree,
    zhe_line,
    tableDataOf,
    liData,
    data_line,
    mapDlist,
    newImge,
    CameraSetings,
    control,
  },
  data() {
    return {
      get_way_uuid: "",
      infoTableList: [], //控制设备数据
      dialogVisibleDataOfSetconft: false,
      dataObjsZlk: {},
      dialogVisibleDataOfCameraset: false,
      selectTabFe: false,
      countLint: 1,
      Successdialog: false,
      formLabelAlign: {
        channelname: "", //通道别名
        upperlimit: "",
        lowerlimit: "", //下线
        upperlimit_alarm: "", //上限报警
        lowerlimit_alarm: "", //下线报警
        remark: "", //报警
        uuid: "",
      },
      listNames: [],
      dialogVisiblemssage: false,
      flyChend: null,
      delectData: "", //删除的通道的uuid
      baojing: baojing,
      zhenchangtupian: zhenchangtupian,
      lixiantupian: lixiantupian,
      uuidData: "",
      flyTabZhe: true,
      addressphoto: "", //现场图片
      flyTitleName: "",
      valueUiid: 0,
      tiemFnet: true,
      // NETS:true,
      begindateEnd: "",
      enddateEnd: "",
      optionsChiiend: [],
      roletype: sessionStorage.getItem("roletypeValue"),
      dialogVisibleDataOf: false, //历史数据据弹框
      dateset: "1day", //1week
      activeNames: [2],
      dialogVisible: false,
      treeData: [],
      gateway_uuid: "358D0BC864963CF393AD5958DD013136",
      pagenum: 1, //页数
      pagesize: 1, //页码
      Delectloading: false,
      textContent: "正在努力加载中...",
      channelinfo: [],
      flyaThat: "",
      objList: "",
      customer_uuidNet: "",
      // che: [],
      lang_file: sessionStorage.getItem("lang_file"),
      tableData: [],
      channelid: [],
      dataX: [], //数据
      collecttime: [], //时间
      // zpagenum: 1,
      uuid_end: "1",
      pageData: {
        zpagenum: 1, //页码  pagenum  2
        zpagesize: 100, //数据   pagesize几条数据
      },
      orderInfoFaly: "",
      channel1: "channel1",
      channelidTitle: [], //子组件的方法
      channelidList: [], //内容
      conetnCunt: [], //动态的内容
      cheidFengxiang: [], //标题有风向的标题
      teab: "", //按钮默认值（折线图）
      value1: [],
      datesetList: "",
      begindate: "", //开始时间
      enddate: "", //结束时间
      fly: "", //判断是否是点击折线图下方的按钮如果是就为false
      titleObj: {},
      ulaneName: "",
      uuList: [],
      teablet: "",
      total: null,
      channelidOne: "",
      dataCheck: "",
      maxMgs: "",
      selectTo: "",
      dataMix: [],
      excle: "",
      gatewaylistZhe: [],
      keystree: [],
      titleChinedListNameDoile: "",
      lowerlimit: [],
      lowrlimt: [],
      btensFlag: "1", //默认是大图标还是小图标或者中图标
      ishow: true,
      times: null,
      tabFlag: [],
      pingName: 16,
      isIcon: false,
      treeHidder: false,
      titeltData: "大图标",
      shshiData: [],
      iconTile: "",
      dataobjsSend: {},
      timeClent: null,
      flytTime: true,
      timeClentLinet: null,
      timesINte: "",
      flyNameicont: "",
      uuidEnd: [],
      refultSha: false, //下拉框记录
      Dodata: {},
      iconFint: [],
      khUUid: "",
      countListName: [],
      flyTimeFlet: "2",
      INnner: "",
      getvalue: "",
      setBten: [
        {
          id: 0,
          title: "上升",
          url: require("@/assets/img/shangsheng-1.png"),
          acitve: require("@/assets/img/shangsheng.png"),
          status: "1",
          status2: "0",
        },
        {
          id: "00",
          title: "停止",
          url: require("@/assets/img/tingzhi-1.png"),
          acitve: require("@/assets/img/tingzhi.png"),
          status: "0",
          status2: "0",
        },
        {
          id: 1,
          title: "下降",
          url: require("@/assets/img/xiajiang-1.png"),
          acitve: require("@/assets/img/xiajiang.png"),
          status: "0",
          status2: "1", //行程量
        },
      ],
    };
  },
  computed: {
    ...mapState(["nameTiles"]),
    handPath() {
      if (this.$route.query.fly) {
        // console.log(this.$route.query,"5555")
        let uuuid = sessionStorage.getItem("flyGet");
        console.log(uuuid);
        this.getvalue = uuuid;
        this.$store.commit("getUUid_value", uuuid);
        this.dialogVisibleDataOfCameraset = true;
      }
    },
  },
  // 监听路由离开当前页面
  beforeDestroy() {
    clearInterval(this.timeClentLinet);
    this.timeClentLinet = null;
  },
  mounted() {
    // 防止进入把记录的图标清除（没有离开其他页面的时候
    //iconFint这个里面是有值的如果离开了里面的数据就会清空）
    let bents = JSON.parse(sessionStorage.getItem("clickBtn"));
    if (bents != null) {
      this.iconFint = bents;
    }
    // tab里面的小图标切换 （折叠面板里面的）
    let tabFlagTab = JSON.parse(sessionStorage.getItem("bigIcon"));
    if (tabFlagTab != null) {
      this.tabFlag = tabFlagTab;
    } // console.log(this.timeOut);
    this.lang_fendInt();
    this.treeinfo();

    this.getdataChannelData(); //折线图
    this.monthList();
    this.tableList();
    this.lang_fendFends();
    // this.checcenDN()
    this.lang_fend();
    let nameTitles = sessionStorage.getItem("shshListData");
    if (nameTitles != null) {
      //判断缓存中是否为空
      this.getdataAreaH(nameTitles);
      this.keystree.push(nameTitles);
    } else {
      this.domeJxsData();
      // console.log(111);
    }

    let flyNameicont = sessionStorage.getItem("flyNameicont");
    if (flyNameicont == null) {
      let flyNameicont = sessionStorage.setItem("flyNameicont", 112244);
    }
    // 经销商和客户
    if (this.roletype == 1 || this.roletype == 2) {
      console.log("222");

      this.domeJxsData();
    }
    sessionStorage.setItem("refFly", 1); //1为开启刷新时间

    this.handsetCount();
  },
  methods: {
    //   认证服务
    // client-id：ZHGC
    // client-secret：y1CXCXpir3CQKv6kSBjj3
    getCode() {
      let data = {
        response_type: "code",
        client_id: "ZHGC",
        state: "yuandao",
        redirect_uri: "https://dp.fanzhuo.net.cn/zsapi", //回调地址
      };
      getCode(data).then((res) => {
        console.log(res, "认证服务获取code");
      });
    },
    getToken() {
      let datas = {
        client_id: "ZHGC",
        client_secret: "y1CXCXpir3CQKv6kSBjj3",
        grant_type: "authorization_code",
        code: this.$route.query.code, //通过授权回调query参数上获取
        redirect_uri: "https://dp.fanzhuo.net.cn/zsapi", //回调地址
      };
      getToken(datas).then((resa) => {
        console.log(resa);
      });
    },
    //   登录
    async login() {
      let optpassword = md5("supperadmin");
      const res = await Longin("supperadmin", optpassword.toUpperCase(), "1");
      let objs = {
        optname: this.formLabelAlign.optname,
        optpassword: optpassword.toUpperCase(),
      };
      this.$store.commit("formLabelAlign", objs);
      let { code, msg } = res;
      console.log(res);
      if (code) {
        sessionStorage.setItem("username", res.data.optname); //缓存taoken userName
        sessionStorage.setItem("isagree", res.data.roletype1); //缓存主账号还是子账号
        if (this.checked) {
          this.myoocs(this.formLabelAlign.optname, this.formLabelAlign.optpassword, 7);
        } else {
          // 清空缓存
          this.clearCookie();
        }

        const { appid, roletype } = res.data;
        // this.$message.success("登陆成功");
        sessionStorage.setItem("token", appid); //缓存taoken
        console.log(sessionStorage.getItem("token"));
        //  this.$store.commit('roletypeValue',roletype)
        sessionStorage.setItem("roletypeValue", roletype); //保存当前用户的状态 0 平台 1经销商 2 客户
        // this.$router.push("/home");
        // this.myFengTuClickAll()  //全部刷新
      } else {
        this.clearCookie();
        this.$message.error(msg);
      }
    },
    //删除cookie
    clearCookie() {
      // alert('111')
      this.checked = "";
      this.myoocs("", "", -1); //修改2值都为空，天数为负1天就好了
      this.formLabelAlign = {};
    },
    //设置cookie
    myoocs(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      document.cookie =
        "optname=" + c_name + ";path=/;expires=" + exdate.toLocaleString();
      document.cookie =
        "optpassword=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString();
    },
    //控制r
    confIngHnad(e) {
      this.getWeiUrlData(e);
      this.activeNames.push(e.uuid); //点击不关闭折叠面板
      this.get_way_uuid = e.uuid;
      // this.get_way_uuid = "C3764D04AB7BAF649B7E7806C1FD3420";
      this.gatewaylistZhe.forEach((item) => {
        if (item.uuid == e.uuid) {
          // console.log(item);
          //  item.dealername + "/" +
          this.titleChinedListNameDoile = item.customername + "/" + item.name;
        }
      });

      this.dialogVisibleDataOfSetconft = true;
    },
    //获取控制信息
    async getWeiUrlData(uuid) {
      const { code, data, msg } = await seetHandDatas({
        gateway_uuid: uuid.uuid,
      });
      if (code) {
        data.forEach((item, index) => {
          item.routevalue = Number(item.routevalue);
          // console.log(item.status2 == 0 ,"stateus2",item.status == 0,"1");

          if (item.status2 == 0 && item.status == 0) {
            item.status2 = "00";
          }
          item.bentEs = this.setBten.map((info) => ({
            id: info.id + item.uuid,
            title: info.title,
            url: info.url,
            acitve: info.acitve,
            uids: info.id,
            status: info.status,
            status2: info.status2, //行程量
          }));
        });
        this.infoTableList = data;

        this.orderInfoFaly = data[0].ismanual;
        // console.log( this.orderInfoFaly);
      }
    },
    // 关闭声音
    handleCloseceamed() {
      this.$store.commit("stopCkick", new Date());
      this.$router.push("/homet");
      setTimeout(() => {
        this.$router.push("/list");
      }, 10);
    },
    // 摄像头
    CamerastHand(e) {
      // console.log(e);
      sessionStorage.setItem("flyGet", e.uuid); //1为开启刷新时间
      this.activeNames.push(e.uuid); //点击不关闭折叠面板
      this.getvalue = e.uuid;

      this.$store.commit("getUUid_value", e.uuid);
      this.dialogVisibleDataOfCameraset = true;
    },
    // 滚动
    chuindScllor() {
      // setTimeout(() => {
      //   var element = this.$refs.left;
      //   element.scrollIntoView();
      //   element.scrollIntoView(true);
      //   for (let i = 0; i < 6; i++) {
      //     element.scrollIntoView({ block: "end" });
      //   }
      //   element.scrollIntoView({
      //     behavior: "smooth",
      //     block: "end",
      //     inline: "nearest",
      //   });
      // }, 500);
    },
    //翻译
    async lang_fendInt() {
      let page = "gateway_channel_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      // console.log(data);
      this.Dodata = data;
    },
    // 修改上线线
    iconHand(uuid) {
      console.log(uuid);
      this.formLabelAlign = {
        channelname: uuid.channelname, //通道别名
        upperlimit: uuid.upperlimit,
        lowerlimit: uuid.lowerlimit, //下线
        upperlimit_alarm: uuid.upperlimit_alarm, //上限报警
        lowerlimit_alarm: uuid.lowerlimit_alarm, //下线报警
        remark: uuid.remark, //报警
        uuid: uuid.uuid,
      };
      this.dialogVisiblemssage = true;
    },
    // 修改上线下确定按钮
    async dialogVisiblemssageAdd() {
      const { code, data, msg } = await updataShang(this.formLabelAlign);
      if (code) {
        this.$message.success(msg);
        this.dialogVisiblemssage = false;
        this.getdataAreaH();
      } else {
        this.$message.error(msg);
        this.dialogVisiblemssage = false;
      }
    },
    // 删除全部数据
    mantClick() {
      let uuid = this.delectData;
      let tablename = "tb_gateway_data";
      this.$confirm("删除网关数据将无法恢复，确定删除此网关数据吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          const { code, data, msg } = await dealerDelete(uuid, tablename);
          if (code) {
            this.$message({
              type: "success",
              message: msg,
            });
          }
          this.pageData.zpagenum = 1;
          this.getdataChannelData();
          this.tableList();
          //
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //展开级别下来框
    countClickTree(treeValue) {
      this.keystree = treeValue;
    },
    // 计时倒计时
    handsetCount() {
      let tiems = sessionStorage.getItem("refreshtime");
      let flyTimes = sessionStorage.getItem("flyTimes");
      let counts = tiems;
      this.timeClentLinet = setInterval(() => {
        // console.log( );
        let count = --counts;
        if (count <= 0) {
          // console.log('222');

          counts = tiems;
          if (flyTimes == null) {
            console.log("2");
            //默认值
            // this.domeJxsData();
            this.getdataAreaH();
            return;
          } else if (this.refultSha) {
            console.log("1");
            //下拉框的值
            this.getdataAreaSelect();
          } else {
            this.getdataAreaH(); //最新数据
            console.log("0");
          }
        }
        // console.log(count);
        this.timesINte = count;
      }, 1000);
    },
    // 是否开启刷新
    guanbiTab() {
      if (this.tiemFnet === true) {
        //刷新
        this.handsetCount();
        sessionStorage.setItem("refFly", 1); //1为开启刷新时间
        return;
      }
      sessionStorage.setItem("refFly", 2); //2为关闭刷新时间
      //停止刷新

      clearInterval(this.timeClent);
      this.timeClent = null;

      clearInterval(this.timeClentLinet);
      this.timeClentLinet = null;
    },

    // 全部刷新
    async myFengTuClickAll(e) {
      // console.log(e);

      // console.log( this.valueUiid);
      if (this.valueUiid == 0) {
        let nameTitles = sessionStorage.getItem("shshListData");
        let shshListData = sessionStorage.getItem("shshListData");
        let clickBtn = JSON.parse(sessionStorage.getItem("clickBtn"));

        // console.log(clickBtn);

        let flag = 1;
        const { code, data } = await getdataAreaH(flag, nameTitles);
        // console.log(data);
        let uuid_end = 1;
        let flyNameicont = sessionStorage.getItem("flyNameicont");
        let icon = flyNameicont.split(",");
        //  console.log(icon);
        if (clickBtn != null) {
          clickBtn.forEach((items) => {
            if (items.uuid === shshListData) {
              uuid_end = items.icon;
            }
          });
        } else {
          uuid_end = 1;
        }
        let arrTicon = []; //存放的数据
        let bigIcon = JSON.parse(sessionStorage.getItem("bigIcon"));
        data.gatewaylist.forEach((item, index) => {
          bigIcon.forEach((itemicon) => {
            if (itemicon.uuid == item.uuid) {
              item.flyus = itemicon.icon; //大图标
              item.iconTile =
                itemicon.icon == 1
                  ? this.dataobjsSend.datubiao
                  : itemicon.icon == 2
                  ? this.dataobjsSend.zhongtubiao
                  : this.dataobjsSend.xiaotubiao; //大图标
              let AlintData = arrTicon.findIndex((itemIs) => itemIs.uuid == item.uuid);

              if (AlintData == -1) {
                arrTicon.push(item);
              }
            }
          });

          let AlintData = arrTicon.findIndex((itemIs) => itemIs.uuid == item.uuid);
          if (AlintData == -1) {
            let arrn =
              uuid_end == 1
                ? this.dataobjsSend.datubiao
                : uuid_end == 2
                ? this.dataobjsSend.zhongtubiao
                : uuid_end == 3
                ? this.dataobjsSend.xiaotubiao //大图标
                : ""; //如果为null的话就是大图标
            item.iconTile = arrn;

            item.flyus = uuid_end;
            arrTicon.push(item);
          }
        });
        this.gatewaylistZhe = arrTicon;
      } else {
        this.getdataAreaSelect();
      }
      clearInterval(this.timeClentLinet);
      this.timeClentLinet = null;
      this.handsetCount();
    },
    // 翻译
    async lang_fend() {
      let page = "realtimedata_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);

      this.dataobjsSend = data;
      this.titeltData = data.datubiao;
      this.iconTile = data.datubiao;
    },
    // 隐藏树
    isShowFly() {
      this.treeHidder = !this.treeHidder;
    },
    // 下拉狂框的数据
    beforeHandleCommand(index, row, command) {
      return {
        index: index, //数据
        row: row, //下表
        command: command,
      };
    },
    listn(item) {
      this.activeNames.push(item.uuid); //点击不关闭折叠面板
    },
    // 折叠面板的大图标切换
    newLIneIcon(item) {
      // console.log(item.index.uuid);

      this.activeNames.push(item.index.uuid); //点击不关闭折叠面板
      // 先判断数据里面是否有重复数据
      let fly = this.tabFlag.findIndex((items) => items.uuid == item.index.uuid);
      if (fly == -1) {
        this.tabFlag.push({
          uuid: item.index.uuid,
          icon: item.command,
        });
      } else {
        // 如果重复的数据删除掉
        let fly = this.tabFlag.splice(
          this.tabFlag.findIndex((items) => items.uuid == item.index.uuid),
          1
        );
        this.tabFlag.push({
          uuid: item.index.uuid,
          icon: item.command,
        });
      }
      sessionStorage.setItem("bigIcon", JSON.stringify(this.tabFlag));
      let flyNet = []; //存在的数据
      //判断是大图标还是小图标中图标
      let arr = this.gatewaylistZhe.forEach((itemData) => {
        if (itemData.uuid == item.index.uuid) {
          itemData.iconTile =
            item.command == 1
              ? this.dataobjsSend.datubiao
              : item.command == 2
              ? this.dataobjsSend.zhongtubiao
              : this.dataobjsSend.xiaotubiao;
          itemData.flyus = item.command;
          flyNet.push(itemData);
        } else {
          flyNet.push(itemData);
        }
      });

      this.gatewaylistZhe = flyNet;
    },
    // 放大图标
    myFengTuClick(e) {
      if (this.roletype == 2) {
        //客户
        this.iconFint.splice(
          this.iconFint.findIndex((item) => item.uuid === this.khUUid),
          1
        );

        this.iconFint.push({
          // uuid: this.gateway_uuid == ''? this.btensFlag: '',
          uuid: this.khUUid,
          icon: e,
        });
      } else {
        //其他
        this.iconFint.splice(
          this.iconFint.findIndex((item) => item.uuid === this.btensFlag),
          1
        );

        this.iconFint.push({
          // uuid: this.gateway_uuid == ''? this.btensFlag: '',
          uuid: this.btensFlag,
          icon: e,
        });
      }
      sessionStorage.setItem("clickBtn", JSON.stringify(this.iconFint));
      if (e == 1) {
        //大
        let net = [];
        this.gatewaylistZhe.forEach((item) => {
          if (this.uuidEnd.indexOf(item.uuid) == -1) {
            this.uuidEnd.push(item.uuid);
            sessionStorage.setItem("flyNameicont", this.uuidEnd); //判读是大图标还是小图标
          }
          item.flyus = 1;
          this.titeltData = this.dataobjsSend.datubiao;
          this.iconTile = this.dataobjsSend.datubiao;
          item.iconTile = undefined; //为了让大小图标统一
          net.push(item);
        });
        this.gatewaylistZhe = net;
      } else if (e == 2) {
        // console.log(222);
        //中图标
        let net = [];
        this.gatewaylistZhe.forEach((item) => {
          if (this.uuidEnd.indexOf(item.uuid) == -1) {
            this.uuidEnd.push(item.uuid);
            // sessionStorage.setItem("flyNameicont", this.uuidEnd); //判读是大图标还是小图标
          }
          item.flyus = 2;
          this.titeltData = this.dataobjsSend.zhongtubiao;
          item.iconTile = this.dataobjsSend.zhongtubiao;
          // }
          net.push(item);
        });
        this.gatewaylistZhe = net;
      } else {
        //小图标
        this.uuidEnd = [];
        this.titeltData = this.dataobjsSend.xiaotubiao;
        this.iconTile = this.dataobjsSend.xiaotubiao; //折叠的大小图标
        let net = [];
        this.gatewaylistZhe.forEach((item) => {
          item.flyus = 3;
          item.iconTile = this.dataobjsSend.xiaotubiao;
          net.push(item);
        });
        this.gatewaylistZhe = net;
      }
    },
    //默认展开经销商
    async domeJxsData() {
      // console.log('222');
      let tree = []; //展开默认值
      let keystree = [];
      let datas = [];
      const { code, data } = await dataInfoName();
      console.log(data);
      // alert("11")
      if (this.roletype != 2) {
        //当不是客户的时候走这里
        let lengthInfo = data.default.length - 1;
        this.btensFlag = data.data.arealist[0].customer_uuid; //只用一次
        this.keystree.push(data.default[lengthInfo].uuid);
        let nameTitles = sessionStorage.setItem(
          "shshListData",
          data.default[lengthInfo].uuid
        );
      }

      this.selectTabFe = data.data.pagelist[0].allpage > 1;
      this.flyaThat = data.data.arealist.length > 1 ? "1" : "2";
      let conunt = Number(data.data.pagelist[0].allpage);
      //  console.log(conunt);
      let arrInfo = [];
      for (let i = 0; i < conunt; i++) {
        // console.log(i);
        arrInfo.push({
          id: Number(i) + 1,
          lableL: this.lang_file == "zh-cn" ? "第" + (i + 1) + "页" : "Page" + (i + 1),
        });
      }
      this.countListName = arrInfo;
      this.treeINnfo = tree; //默认展开树
      // this.gatewaylistZhe = data.data; //渲染折叠面板 = data.data.gatewaylist
      /***大小图切换 */
      // console.log("111");
      let nofLY = [];
      let dataus = data.data.gatewaylist;
      let flyNameicont = sessionStorage.getItem("flyNameicont");

      let clickBtn = sessionStorage.getItem("clickBtn");
      // console.log(clickBtn);

      let icon = flyNameicont.split(",");

      dataus.forEach((item) => {
        let ins = icon.indexOf(item.uuid);
        console.log(ins);
        if (item.uuid == icon[ins]) {
          //大图标
          item.iconTile = this.dataobjsSend.datubiao;
          item.flyus = clickBtn;
          nofLY.push(item);
          let arrn =
            clickBtn == 1
              ? this.dataobjsSend.datubiao
              : clickBtn == 2
              ? this.dataobjsSend.zhongtubiao
              : this.dataobjsSend.xiaotubiao;

          this.titeltData = arrn;
        } else {
          //小图标
          // console.log('22');

          item.iconTile = this.dataobjsSend.xiaotubiao;
          item.flyus = 1; //大图标
          nofLY.push(item);
        }

        // item.flyus = true;
        // nofLY.push(item);
      });
      this.khUUid = data.data.arealist[0].customer_uuid;
      if (this.roletype == 2) {
        sessionStorage.setItem("shshListData", data.data.arealist[0].customer_uuid);
      }
      // console.log(nofLY);

      this.gatewaylistZhe = nofLY; //切换的值

      this.optionsChiiend = data.data.arealist; //下拉框
      this.valueUiid = 0; //下拉框默认值

      // console.log(data.data.arealist[0]);

      let titleInfo = [];
      data.data.gatewaylist.forEach((item) => {
        this.activeNames.push(item.uuid); //全部打开
        let dataChannelId = item.data.channelinfo;
        dataChannelId.forEach((itemIfo) => {
          if (
            itemIfo.unittype != "风向" &&
            itemIfo.unittype != "最大降雨量" &&
            itemIfo.unittype != "最小降雨量" &&
            itemIfo.unittype != "最大降雨时间" &&
            itemIfo.unittype != "雨雪"
          ) {
            titleInfo.push(itemIfo);
          }
        });
      });
      this.channelidOne = titleInfo[0].channelid;
      this.dataCheck = "channel" + titleInfo[0].channelid;
      this.teablet = "channel" + titleInfo[0].channelid;
      this.tableData = titleInfo;
      this.maxMgs = titleInfo[0].channelid;
      datas.push(
        {
          lte: Number(titleInfo[0].lowerlimit), //小于等于  gte//大于等于   //gt大于   //lt小于
          color: "blue",
        },
        {
          gt: Number(titleInfo[0].lowerlimit),
          lte: Number(titleInfo[0].upperlimit),
          color: "green",
        },
        {
          gt: Number(titleInfo[0].upperlimit),
          color: "red",
        }
      );

      this.dataMix = datas;
    },
    //通过下拉框
    mychange() {
      // console.log(this.valueUiid);
      this.ishow = false;
      if (this.valueUiid != 0) {
        this.refultSha = true; //当点击下拉框的时候计时器就会走这个方法
        this.getdataAreaSelect();
        this.selectTo = "";
      } else {
        this.refultSha = false;
        this.getdataAreaHtse(); //全部
      }
    },
    // 全部的方法 下拉框
    async getdataAreaHtse() {
      let datas = [];
      let nameTitles = sessionStorage.getItem("shshListData");
      let areaflag = 1;
      const { code, data, msg } = await getdataAreaHtse(nameTitles, areaflag);
      let nofLY = [];
      let dataus = data.gatewaylist;
      let flyNameicont = sessionStorage.getItem("flyNameicont");
      let icon = flyNameicont.split(",");
      dataus.forEach((item) => {
        let ins = icon.indexOf(item.uuid);
        if (item.uuid == icon[ins]) {
          item.iconTile = this.dataobjsSend.datubiao;
          item.flyus = false;
          nofLY.push(item);
        } else {
          item.iconTile = this.dataobjsSend.xiaotubiao;
          item.flyus = true;
          nofLY.push(item);
        }
      });
      // console.log(nofLY);
      this.gatewaylistZhe = nofLY;

      this.optionsChiiend = data.arealist; //下拉框

      if (this.ishow) {
        // this.valueUiid = data.arealist[0].uuid; //下拉框默认值
        this.valueUiid = 0;
      }

      /**获取channelid的值 和 筛选 如果是风向，最大降雨量等不显示 */
      let titleInfoOUt = [];
      data.gatewaylist.forEach((item) => {
        this.activeNames.push(item.uuid);
        let dataChannelId = item.data.channelinfo;
        if (item.data != "") {
          dataChannelId.forEach((itemIfo) => {
            if (
              itemIfo.unittype != "风向" &&
              itemIfo.unittype != "最大降雨量" &&
              itemIfo.unittype != "最小降雨量" &&
              itemIfo.unittype != "最大降雨时间" &&
              itemIfo.unittype != "雨雪"
            ) {
              titleInfoOUt.push(itemIfo);
            }
          });
        }
      });
      // console.log(titleInfoOUt);
      /**给echars 折线加颜色 */

      datas.push(
        {
          lte: Number(titleInfoOUt[0].lowerlimit), //小于等于  gte//大于等于   //gt大于   //lt小于
          color: "blue",
        },
        {
          gt: Number(titleInfoOUt[0].lowerlimit),
          lte: Number(titleInfoOUt[0].upperlimit),
          color: "green",
        },
        {
          gt: Number(titleInfoOUt[0].upperlimit),
          color: "red",
        }
      );

      this.dataMix = datas;

      this.maxMgs = titleInfoOUt[0].channelid;
    },
    // 通过下拉款显示区域
    async getdataAreaSelect() {
      let datas = [];
      // console.log('111');
      let bigIcon = JSON.parse(sessionStorage.getItem("bigIcon"));
      let shshListData = sessionStorage.getItem("shshListData");
      // console.log(clickBtn,"555");
      let clickBtn = JSON.parse(sessionStorage.getItem("clickBtn"));

      //获取缓存中记录的是大图标还是小图标
      if (clickBtn != null) {
        clickBtn.forEach((items) => {
          if (items.uuid === shshListData) {
            this.uuid_end = items.icon;
          }
        });
      } else {
        this.uuid_end = 1;
      }
      const { code, data, msg } = await getdataAreaSelect(this.valueUiid);
      if (code) {
        let nofLY = [];
        let dataus = data.gatewaylist;
        let flyNameicont = sessionStorage.getItem("flyNameicont");
        /**判断大图标还是小图标 */
        dataus.forEach((item) => {
          if (bigIcon != null) {
            bigIcon.forEach((itemEnd) => {
              if (item.uuid === itemEnd.uuid) {
                item.iconTile =
                  itemEnd.icon == 1
                    ? this.dataobjsSend.datubiao
                    : itemEnd.icon == 2
                    ? this.dataobjsSend.zhongtubiao
                    : this.dataobjsSend.xiaotubiao;

                item.flyus = itemEnd.icon;
                console.log(item);
                let flyN = nofLY.findIndex((itemL) => itemL.uuid == item.uuid);
                if (flyN == -1) {
                  nofLY.push(item);
                }
              }
            });
          }

          let flyN = nofLY.findIndex((itemL) => itemL.uuid == item.uuid);
          if (flyN == -1) {
            item.iconTile =
              this.uuid_end == 1
                ? this.dataobjsSend.datubiao
                : this.uuid_end == 2
                ? this.dataobjsSend.zhongtubiao
                : this.uuid_end == 3
                ? this.dataobjsSend.xiaotubiao
                : "";
            item.flyus = this.uuid_end; //大图标
            nofLY.push(item);
          }
        });
        this.gatewaylistZhe = nofLY; //给折叠面板数据

        this.optionsChiiend = data.arealist; //下拉框

        if (this.ishow) {
          this.valueUiid = 0;
        }

        /**获取channelid的值 和 筛选 如果是风向，最大降雨量等不显示 */
        let titleInfoOUt = [];
        data.gatewaylist.forEach((item) => {
          this.activeNames.push(item.uuid);
          let dataChannelId = item.data.channelinfo;
          if (item.data != "") {
            dataChannelId.forEach((itemIfo) => {
              if (
                itemIfo.unittype != "风向" &&
                itemIfo.unittype != "最大降雨量" &&
                itemIfo.unittype != "最小降雨量" &&
                itemIfo.unittype != "最大降雨时间" &&
                itemIfo.unittype != "雨雪"
              ) {
                titleInfoOUt.push(itemIfo);
              }
            });
          }
        });

        /**给echart折线图标颜色 */
        datas.push(
          {
            lte: Number(titleInfoOUt[0].lowerlimit), //小于等于  gte//大于等于   //gt大于   //lt小于
            color: "blue",
          },
          {
            gt: Number(titleInfoOUt[0].lowerlimit),
            lte: Number(titleInfoOUt[0].upperlimit),
            color: "green",
          },
          {
            gt: Number(titleInfoOUt[0].upperlimit),
            color: "red",
          }
        );

        this.dataMix = datas;
        this.maxMgs = titleInfoOUt[0].channelid;
      } else {
        this.$message.error(msg);
        this.gatewaylistZhe = "";
      }
    },
    mychangeCount() {
      this.getdataAreaH();
    },
    // 点击树的下拉框
    async getdataAreaH() {
      /**这里是判断全部折叠的 如果 this.flyTimeFlet == 1的话就折叠其他就展开 */
      if (this.flyTimeFlet == 1) {
        //折叠

        if (this.INnner != "") {
          /**如果点击了展开的展开模板 */
          this.activeNames.splice(
            this.activeNames.findIndex((item) => item == this.INnner),
            1
          ); //如果有样的就删除掉

          this.activeNames.push(this.INnner);
        } else {
          //其他的时候就清空
          this.activeNames = [];
        }
      }

      //获取当前点击树形控件的uuid
      let customer_uuid = sessionStorage.getItem("shshListData");

      let pagesize = 30;
      let pagenum = this.countLint;
      let datas = [];
      let ant = 1;
      const { code, data, msg } = await getdataAreaH(
        ant,
        customer_uuid,
        pagesize,
        pagenum
      );

      /***
       * 分页下拉框
       */
      this.selectTabFe = data.pagelist[0].allpage > 1;

      let conunt = Number(data.pagelist[0].allpage);
      //  console.log(conunt);
      let arrInfo = [];
      for (let i = 0; i < conunt; i++) {
        arrInfo.push({
          id: Number(i) + 1,
          lableL: this.lang_file == "zh-cn" ? "第" + (i + 1) + "页" : "Page" + (i + 1),
        });
      }
      this.countListName = arrInfo;

      // 如果是默认区域就显示（如果大于1就不显示默认区域，其他就显示）
      this.flyaThat = data.arealist.length > 1 ? "1" : "2";

      let nofLY = [];
      let dataus = data.gatewaylist;
      let shshListData = sessionStorage.getItem("shshListData");
      let clickBtn = JSON.parse(sessionStorage.getItem("clickBtn"));
      let bigIcon = JSON.parse(sessionStorage.getItem("bigIcon"));
      // console.log(bigIcon);

      //获取缓存中记录的是大图标还是小图标
      if (clickBtn != null) {
        //如果缓存中是空的
        clickBtn.forEach((items) => {
          // console.log(items);

          if (items.uuid === shshListData) {
            this.uuid_end = items.icon; //通过这个来判断是大图标还是小图标中图标
            this.titeltData =
              items.icon == 1 //最上面的大图标
                ? this.dataobjsSend.datubiao
                : items.icon == 2
                ? this.dataobjsSend.zhongtubiao
                : this.dataobjsSend.xiaotubiao;
          }
        });
      } else {
        //就是大图标
        this.uuid_end = 1;
      }
      /**
 * else{
            this.titeltData = '大图标'
          }
 */
      let ling = [];

      dataus.forEach((item, index) => {
        if (bigIcon != null) {
          bigIcon.forEach((itemIn) => {
            if (itemIn.uuid === item.uuid) {
              item.flyus = itemIn.icon; //大图标
              item.iconTile =
                itemIn.icon == 1
                  ? this.dataobjsSend.datubiao
                  : itemIn.icon == 2
                  ? this.dataobjsSend.zhongtubiao
                  : this.dataobjsSend.xiaotubiao; //大图标 title的大图标

              // console.log( itemIn.icon);
              let AlintData = ling.findIndex((itemIs) => itemIs.uuid == item.uuid);

              if (AlintData == -1) {
                ling.push(item);
              } else {
                //清空内容
                let AlintData = ling.splice(
                  ling.findIndex((itemIs) => itemIs.uuid == item.uuid),
                  1
                );
                ling.push(item);
              }
            }
          });
        }
        // console.log( this.uuid_end);

        let AlintData = ling.findIndex(
          //判断里面是否有重复的数据
          (itemIs) => itemIs.uuid == item.uuid
        );
        if (AlintData == -1) {
          item.iconTile =
            this.uuid_end == 1
              ? this.dataobjsSend.datubiao
              : this.uuid_end == 2
              ? this.dataobjsSend.zhongtubiao
              : this.uuid_end == 3
              ? this.dataobjsSend.xiaotubiao
              : "";
          item.flyus = this.uuid_end; //大图标
          let arrn =
            this.uuid_end == 1
              ? this.dataobjsSend.datubiao
              : this.uuid_end == 2
              ? this.dataobjsSend.zhongtubiao
              : this.uuid_end == 3
              ? this.dataobjsSend.xiaotubiao
              : ""; //如果为null的话就是大图标
          ling.push(item);
        }
      });

      this.gatewaylistZhe = ling;

      console.log(this.gatewaylistZhe, 123);

      this.optionsChiiend = data.arealist; //下拉框

      /**获取channelid的值 和 筛选 如果是风向，最大降雨量等不显示 */
      let titleInfoOUt = [];
      data.gatewaylist.forEach((item) => {
        if (this.flyTimeFlet == 2 || this.flyTimeFlet == "") {
          //等于2的话就是展开
          this.activeNames.push(item.uuid);
        }

        let dataChannelId = item.data.channelinfo;
        if (item.data != "") {
          dataChannelId.forEach((itemIfo) => {
            if (
              itemIfo.unittype != "风向" &&
              itemIfo.unittype != "最大降雨量" &&
              itemIfo.unittype != "最小降雨量" &&
              itemIfo.unittype != "最大降雨时间" &&
              itemIfo.unittype != "雨雪"
            ) {
              titleInfoOUt.push(itemIfo);
            }
          });
        }
      });
      // console.log(titleInfoOUt);

      datas.push(
        {
          lte: Number(titleInfoOUt[0].lowerlimit), //小于等于  gte//大于等于   //gt大于   //lt小于
          color: "blue",
        },
        {
          gt: Number(titleInfoOUt[0].lowerlimit),
          lte: Number(titleInfoOUt[0].upperlimit),
          color: "green",
        },
        {
          gt: Number(titleInfoOUt[0].upperlimit),
          color: "red",
        }
      );

      this.dataMix = datas;

      this.maxMgs = titleInfoOUt[0].channelid;
    },
    // 下载ex
    myFileupData() {
      let { begindate, enddate, dateset, gateway_uuid } = this; //获取年月日

      let appid = sessionStorage.getItem("token");

      const lang_file = sessionStorage.getItem("lang_file");
      if (this.excle != "") {
        location.href =
          swart +
          `/Gatewaydata/getdata_export?begindate=${begindate}&enddate=${enddate}&dateset=${dateset}&gateway_uuid=${gateway_uuid}&appid=${appid}&lang_file=${lang_file}`;
      } else {
        this.$message.error("数据不能为空");
      }
    },
    //获取最大值 折线图
    async getdataCnhannel() {
      this.lowrlimt = [];
      this.dataX = []; //数据channel1
      // console.log( this.dateset,);
      this.collecttime = []; //时间
      if (this.begindateEnd != "") {
        this.dateset = "";
      }
      const { code, data, msg } = await getdataCnhannel(
        this.gateway_uuid,
        this.maxMgs,
        this.dateset,
        this.enddateEnd,
        this.begindateEnd
      );
      // console.log(data)
      if (data != "") {
        this.flyChend = true;
        let datas = [];
        // 获取折线图的标题和单位
        this.titleObj = {
          unit: data.channelinfo[0].unit,
          unittype:
            this.lang_file == "zh-cn"
              ? data.channelinfo[0].unittype
              : data.channelinfo[0].unittype_en,
        };
        this.lowerlimit = []; //清空上线下线
        data.channelinfo.forEach((item) => {
          datas.push(
            {
              lte: Number(item.lowerlimit), //小于等于  gte//大于等于   //gt大于   //lt小于
              color: "blue",
            },
            {
              gt: Number(item.lowerlimit),
              lte: Number(item.upperlimit),
              color: "green",
            },
            {
              gt: Number(item.upperlimit),
              color: "red",
            }
          );

          // 获取线的数据
          this.lowrlimt.push(
            {
              type: "average",
              name: "平均值",
              valueDim: "y",
              // label:'平均值',
              lineStyle: {
                color: "#e6a23c",
                curveness: 0.15,
              },
            },
            {
              yAxis: item.upperlimit, //上限
              //名字
              label: {
                formatter: this.$t("upperLimit"),
              },
              lineStyle: {
                color: "red",
                curveness: 0.15,
              },
            },
            // upperLimit lowerLimit
            {
              yAxis: item.lowerlimit, //下限
              label: {
                formatter: this.$t("lowerLimit"),
              },
              lineStyle: {
                curveness: 0.15,
                color: "blue",
              },
            }
          );
        });
        this.dataMix = datas;

        // 获取x轴 和 Y轴 数据
        data.list.forEach((items) => {
          // console.log(items[this.dataCheck])
          // console.log(this.dataCheck);

          this.dataX.push(items.channeldata); //数据channel1 //数据channel1

          this.collecttime.push(items.collecttime); //时间
        });
      } else {
        this.flyChend = false;
      }

      // }
    },
    // 树 的查询
    serchBten(e) {
      this.flyTay = true;
      this.treeinfo(e);
    },
    // 关闭
    cloneDelect(index) {
      // console.log(index);
      this.gatewaylistZhe.splice(index, 1);
    },
    // 折叠
    zheclick() {
      this.flyTimeFlet = 1;
      this.activeNames = [];
    },
    // 展开
    myClick() {
      // console.log(this.che);
      this.flyTimeFlet = 2;
      let arrlist = [];
      this.gatewaylistZhe.forEach((item) => {
        // console.log(item);
        arrlist.push(item.uuid);
      });
      this.activeNames = arrlist;
    },
    // 清空
    myCLOnwe() {
      this.gatewaylistZhe = [];
    },
    handleClose() {
      this.guanbiTab();
      this.$refs.dataLine.channelidType = "";
      this.$refs.dataLine.tabPosition = "";
      this.$refs.dataLine.channelidTtitle = [];

      if (this.$refs.datalineList != undefined) {
        this.$refs.datalineList.channelidTtitle = [];
      }
      this.$refs.dataLine.objUnit.unittype = undefined;
      this.dialogVisible = false;
    },
    /***
     * 实时数据的弹框
     */
    lishData(e) {
      this.fly = e;
      this.flyTitleName =
        e == "实时数据"
          ? this.dataobjsSend.shishishuju
          : e == "历史数据"
          ? this.dataobjsSend.lishishuju
          : e == "地图"
          ? this.dataobjsSend.ditu
          : this.dataobjsSend.xianchangtu; //弹框的标题
      this.dialogVisibleDataOf = true;

      this.$nextTick(() => {
        // console.log(this.$refs.mapDlistRef.dataRewues());
        // this.$$refs.mapDlistRef.marpList();
        // this.$refs.mapDlistRef.marpList()
      });
      if (this.$refs.datalineList != undefined) {
        this.$nextTick(() => {
          //
          this.$refs.datalineList.channelidTypeL(this.ulaneName);
          this.$refs.datalineList.channelidType = this.ulaneName;
          // console.log(this.ulaneName,'------------------');
        });
      }
    },
    /*
    获取一个月的时间
     */
    monthList() {
      let timeArr = [];
      let num = 1;
      var frontOneHour = new Date(new Date().getTime());
      let hwd = new Date(new Date().getTime() - 1 * 60 * 60 * 1000);

      let timesD = timeConvert(hwd, num); //开始时间

      this.begindate = timesD; //开始时间

      let timesEndD = timeConvert(frontOneHour, num); //结束时间
      this.enddate = timesEndD; //结束时间
      timeArr.push(timesD, timesEndD);
      this.value1 = timeArr;
      // console.log(this.value1);
    },
    /**
     * 子组件穿过来的确认按钮
     */
    confingClick(e) {
      // console.log(e);
      this.begindate = e[0];
      this.enddate = e[1];
      this.enddateEnd = e[1];
      this.begindateEnd = e[0];
      this.value1 = e;
      this.getdataCnhannel();

      this.getdataChannelData();
    },
    // 子组件传出的 时间 天 周 月
    dayTime(day) {
      let num = 1;
      let timeArr = [];
      var frontOneHour = new Date(new Date().getTime());
      /**获取 1小时 2销售  1天 1周  1个月 */
      switch (day) {
        case "1hour":
          let w = new Date(new Date().getTime() - 1 * 60 * 60 * 1000);
          let times = timeConvert(w, num); //前一个小时
          let timesEnd = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(times, timesEnd);
          this.value1 = timeArr;
          // console.log(  this.value1);

          break;
        case "2hour":
          let hw = new Date(new Date().getTime() - 2 * 60 * 60 * 1000);
          let timesH = timeConvert(hw, num); //前2个小时
          let timesEndH = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(timesH, timesEndH);
          this.value1 = timeArr;
          break;
        case "1day": //天
          let hwd = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
          let timesD = timeConvert(hwd, num); //前2个小时
          let timesEndD = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(timesD, timesEndD);
          this.value1 = timeArr;
          break;
        case "1week": //周
          let hwdK = new Date(new Date().getTime() - 168 * 60 * 60 * 1000);
          let timesDK = timeConvert(hwdK, num); //前2个小时
          let timesEndDK = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(timesDK, timesEndDK);
          this.value1 = timeArr;
          break;
        case "1month": //月
          let hwdKH = new Date(new Date().getTime() - 720 * 60 * 60 * 1000);
          let timesDKH = timeConvert(hwdKH, num); //前2个小时
          let timesEndDKH = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(timesDKH, timesEndDKH);
          this.value1 = timeArr;
          break;
      }
      (this.enddateEnd = ""), (this.begindateEnd = "");
      this.dateset = day;
      //如果点击一小时1天都会从1页开始
      this.pageData.zpagenum = 1;
      this.getdataChannelData();
      // this.tableList();
      this.getdataCnhannel();
    },
    // 子组件的方法
    channelidfunt(e, val) {
      this.maxMgs = val;
      // console.log(val,'---');
      this.channel1 = e; //channid 后台要的id （没有用）
      this.dataCheck = e; //channid 后台要的id
      this.teablet = e; //给最大的折线图传值
      this.ulaneName = e;
      this.channelidOne = val;
      this.getdataCnhannel();
    },
    //最大化折线图
    channelidfuntEnd(e) {
      this.channel1 = e;
      this.$refs.dataLine.channelidTypeL(e);
      // this.$refs.datalineList = this.ulaneName
      this.$refs.dataLine.channelidType = e;

      this.getdataChannelData();
    },
    /**召测数据 */
    tableListZhaoce(e) {
      // console.log(22)

      this.activeNames.push(e.uuid);
      this.$confirm(`${this.dataobjsSend.tishixinxi}`, `${this.Dodata.tishi}`, {
        confirmButtonText: `${this.Dodata.queding}`,
        cancelButtonText: `${this.Dodata.quxiao}`,
        closeOnClickModal: false,
        type: "success",
      })
        .then(async () => {
          // console.log(e);
          let count = 16;

          this.times = setInterval(() => {
            this.pingName = count--;
            this.Successdialog = true;
            if (this.pingName <= 0) {
              clearInterval(this.times);
              count = 16;
              this.Successdialog = false;
              this.$message.error("请求超时");
            }
          }, 1000);
          let pagesize = 1;
          let pagenum = this.pageData.zpagenum;
          let dataIfo = {
            gateway_uuid: e.uuid,
            pagenum,
            pagesize,
            isdevice: 1,
          };
          const { code, data, msg } = await updataList(dataIfo);

          if (code) {
            let nofLY = [];
            let objsData = {};
            let dataChend = this.gatewaylistZhe;
            dataChend.forEach((item) => {
              if (item.uuid == e.uuid) {
                // console.log(item);
                objsData = {
                  areaname: item.areaname,
                  collecttime: data.channelinfo[0].collecttime,
                  customername: item.customername,
                  data: data,
                  dealername: item.dealername,
                  flyus: item.flyus,
                  gatewaydataflag: item.gatewaydataflag,
                  gatewayid: item.gatewayid,
                  iconTile: item.iconTile,
                  name: item.name,
                  state: item.state,
                  uploadtime: item.uploadtime,
                  uuid: item.uuid,
                };
                nofLY.push(objsData);
              } else {
                nofLY.push(item);
                // console.log(item);
              }
            });
            // console.log(data);

            this.gatewaylistZhe = nofLY;
            this.$message.success("召测成功");
            this.Successdialog = false;

            clearInterval(this.times);
            count = 16;
          } else {
            // console.log(  this.times);
            // count = 16;
            this.Successdialog = false;
            clearInterval(this.times); //关闭计时器
            // this.pingName = msg; //提示内容

            this.pingName = 16;
            this.$message.error(msg);
          }
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.Dodata.yiquxiao}`,
          });
        });
    },
    /***
     * 数据列表
     */
    async tableList() {
      let pagesize = this.pageData.zpagesize;
      let pagenum = this.pageData.zpagenum;
      // console.log(this.begindate);

      let channelid = this.channelidOne;
      let dataIfo = {
        gateway_uuid: this.gateway_uuid,
        pagenum,
        pagesize,
        dateset: this.dateset,
        // begindate: this.begindate,
        // enddate: this.enddate,
        channelid,
      };

      const { code, data, msg } = await getdata(dataIfo);
      // console.log(data,"---");
      // console.log(111);

      if (code) {
        this.cheidFengxiang = [];
        this.conetnCunt = [];
        if (data != "") {
          let phusList = [];
          this.channelidList = [];
          this.total = Number(data.pagelist[0].allrow);
          let lengthInfo = data.channelinfo.length;
          for (let i = 0; i < lengthInfo; i++) {
            let ints = i + 1;
            phusList.push("channel" + ints);
          }
          let arr = phusList;
          this.conetnCunt = arr;

          /**显示风向标题 */
          this.cheidFengxiang = data.channelinfo;

          this.channelidList = data.list;
        }
      }
    },

    // 数据列表二
    async tableListTow() {
      let pagesize = this.pageData.zpagesize;
      let pagenum = this.pageData.zpagenum;
      // console.log(this.begindate);

      let channelid = this.channelidOne;
      let dataIfo = {
        gateway_uuid: this.gateway_uuid,
        pagenum,
        pagesize,
        // dateset: this.dateset,
        begindate: this.begindate,
        enddate: this.enddate,
        channelid,
      };

      const { code, data, msg } = await getdata(dataIfo);
      // console.log(data,"---");
      // console.log(111);

      if (code) {
        this.cheidFengxiang = [];
        this.conetnCunt = [];
        this.excle = data;
        if (data != "") {
          let phusList = [];
          this.channelidList = [];
          this.total = Number(data.pagelist[0].allrow);
          let lengthInfo = data.channelinfo.length;
          for (let i = 0; i < lengthInfo; i++) {
            let ints = i + 1;
            phusList.push("channel" + ints);
          }
          let arr = phusList;
          // console.log(arr);

          this.conetnCunt = arr;

          /**显示风向标题 */
          this.cheidFengxiang = data.channelinfo;

          this.channelidList = data.list;
        }
      }
    },
    // 折线数据
    async getdataChannelData() {
      this.dataX = [];
      this.collecttime = [];
      let pagesize = 100;
      let pagenum = this.pageData.zpagenum;
      let channelid = this.channelidOne;
      let datainfo = {
        gateway_uuid: this.gateway_uuid,
        pagenum,
        pagesize,
        dateset: this.dateset,
        begindate: this.begindate,
        enddate: this.enddate,
        channelid,
      };
      // console.log(channelidOTS);
      this.lowrlimt = [];
      this.lowerlimit = [];
      const { code, data, msg } = await getdata(datainfo);
      // console.log(data,"111");

      if (code) {
        // table表格的内容和标头 分页
        let phusList = [];
        this.channelidList = [];
        if (data != "") {
          // console.log('22222222');

          this.excle = data;
          this.total = Number(data.pagelist[0].allrow);
          let lengthInfo = data.channelinfo.length;
          for (let i = 0; i < lengthInfo; i++) {
            let ints = i + 1;
            phusList.push("channel" + ints);
          }
          let arr = phusList;
          this.conetnCunt = arr;
        } else {
          this.excle = ""; //exs
        }

        /**显示风向标题 */
        this.cheidFengxiang = data != "" ? data.channelinfo : [];

        this.channelidList = data != "" ? data.list : [];
        /*
          显示系统默认值按钮
          */
        if (data.channelinfo !== undefined && data.channelinfo.length > 0) {
          // console.log(data.channelinfo[0].channelid)

          let arrNot = [];
          data.channelinfo.forEach((item) => {
            if (
              item.unittype != "风向" &&
              item.unittype != "最大降雨量" &&
              item.unittype != "最小降雨量" &&
              item.unittype != "最大降雨时间" &&
              item.unittype != "雨雪"
            ) {
              arrNot.push(item);
            }
          });
          this.teab = "channel" + arrNot[0].channelid;
          this.channel1 = "channel" + arrNot[0].channelid;
          this.titleObj = {
            unit: arrNot[0].unit,
            unittype:
              this.lang_file == "zh-cn" ? arrNot[0].unittype : arrNot[0].unittype_en,
          };
        }

        if (data != "") {
          /**
           * 折线图切换按钮
           */
          let channelinfolist = [];

          data.channelinfo.forEach((item) => {
            if (
              item.unittype != "风向" &&
              item.unittype != "最大降雨量" &&
              item.unittype != "最小降雨量" &&
              item.unittype != "最大降雨时间" &&
              item.unittype != "雨雪"
            ) {
              channelinfolist.push(item);
            }
          });
          // console.log(channelinfolist)
          this.channelidTitle = channelinfolist;
        }
      }
    },
    async trreList(e) {
      let tdh = []; //获取通道号
      this.gateway_uuid = e;
      this.btensFlag = e; //大小图标的
      // this.tabFlag = e;
      let customer_uuid = e;
      this.selectTo = e;
      this.customer_uuidNet = e;
      this.countLint = 1;
      this.flytTime = false;
      // this.$store.commit("shshListData", e);
      sessionStorage.setItem("shshListData", e);
      sessionStorage.setItem("flyTimes", true);
      // console.log(e);
      this.flyTimeFlet = "";
      this.getdataAreaH(customer_uuid);
      let fly = this.iconFint.findIndex((item) => item.uuid == e);
      // console.log(this.iconFint);

      if (fly == -1) {
        this.iconFint.push({
          uuid: e,
          icon: 1,
        });
        // console.log(this.iconFint);
        sessionStorage.setItem("clickBtn", JSON.stringify(this.iconFint));
      }
      let aint = this.listNames.findIndex((item) => item.uuid == e);
      if (aint == -1) {
        this.listNames.push({ uuid: e });
        sessionStorage.setItem("keys", JSON.stringify(this.listNames));
      }

      this.refultSha = false; //下拉框的值
      // setTimeout(()=>{
      this.activeNames = [];
      // },1000)

      // clearInterval(this.timeClent);
      // this.timeClent = null;

      clearInterval(this.timeClentLinet);
      this.timeClentLinet = null;
      // this.refalut();
      let ferf = sessionStorage.getItem("refFly");
      if (ferf != 2) {
        this.handsetCount();
      }
    },
    // 获取图片信息
    async newIMGSList(uuid) {
      const { code, data } = await imgUpdataXchang(uuid);
      // console.log(data);
      this.addressphoto = data[0].addressphoto;
    },

    // 折线图数据 点击
    newLIne(e) {
      this.newIMGSList(e.uuid); //获取现场图片/
      this.shshiData = e.data.channelinfo;
      let tdh = []; //获取通道号
      this.gateway_uuid = e.uuid;
      this.delectData = e.uuid;
      this.activeNames.push(e.uuid);
      this.$store.commit("uuidClick", e.uuid);
      sessionStorage.setItem("gatewayuuidIfo", e.uuid); //缓存uuid
      this.gatewaylistZhe.forEach((item) => {
        if (item.uuid == e.uuid) {
          // console.log(item);
          //  item.dealername + "/" +
          this.titleChinedListNameDoile = item.customername + "/" + item.name;
          let dataINfo = item.data.channelinfo; //获取通道号
          dataINfo.forEach((items) => {
            if (
              items.unittype != "风向" &&
              items.unittype != "最大降雨量" &&
              items.unittype != "最小降雨量" &&
              items.unittype != "最大降雨时间" &&
              items.unittype != "雨雪"
            ) {
              // console.log(items,"-------");

              tdh.push(items);
            }
          });
        }
      });
      this.dataCheck = "channel" + tdh[0].channelid;

      this.channelidOne = tdh[0].channelid;
      this.maxMgs = tdh[0].channelid;
      this.dialogVisible = true;
      this.$nextTick(() => {
        // this.$refs.dataLine.dataX = this.dataX;
        this.$refs.dataLine.drawLine();
        // this.$refs.dataLine.channelidType = this.teab; //折线图下面的按钮           dateset
        this.$refs.dataLine.tabPosition = this.dateset;
        // this.$refs.dataLine.value1 = this.value1;
        this.$refs.dataLine.channelidType = this.teab;
      });
      // alert("1111")
      this.getdataCnhannel();
      this.getdataChannelData();

      // 关闭计时器
      clearInterval(this.timeClent);
      this.timeClent = null;

      clearInterval(this.timeClentLinet);
      this.timeClentLinet = null;

      // this.tableList();
    },
    // 刷新
    async setClick() {
      let uuid = this.delectData;
      //  this.newLIne(uuid)
      this.getdataCnhannel();
      this.getdataChannelData();
      //  const { code, data, msg } = await homeGetUidIn(uuid);
      // //  console.log(data)
      //  this.shshiData = data.channelinfo
    },
    // 刷新
    async newLIneIconShuaxin(e, indexs) {
      this.activeNames.push(e.uuid); //点击不关闭折叠面板
      let uuid = e.uuid;
      //  console.log(e);
      const { code, data, msg } = await homeGetUidIn(uuid);
      console.log(data);

      this.gatewaylistZhe.forEach((item, index) => {
        this.gatewaylistZhe[indexs].collecttime = data.channelinfo[index].collecttime;
        // console.log(item.uuid == e.uuid);
        // console.log(item);

        if (item.uuid == e.uuid) {
          // console.log(item.data.channelinfo);
          item.data.channelinfo = data.channelinfo;
          // console.log(item);
        }
      });
    },
    async lang_fendFends() {
      let page = "realtimedata_detail_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);

      this.dataObjsZlk = data;
      // this.xiaoshi = data.1xiaoshi
    },
    handleChange(e) {
      // console.log(e);
      this.INnner = e[0];
    },
    // 树形结构
    async treeinfo(serch) {
      let levelid = 2;
      const { code, data, msg } = await treeinfo(levelid, serch);
      if (code) {
        this.treeData = data;
      }
    },
  },
};
</script>

<style>
.netListDatal {
  height: 100vh;
}
.flexn .el-select .el-input__inner {
  height: 20px !important;
}
.flexn .el-input__suffix {
  margin-top: 12px !important;
}
/* .ponstMap {
  position: relative;
} */
.treeINtnents {
  height: 100% !important;
  overflow: auto;
  /* height: 200px; */
  position: relative;
}
.treeINtnents .el-dialog__body {
  box-sizing: border-box !important;
  padding: 0 !important;
}

.header {
  background: #2d3a4b;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  color: #333;
  text-align: center;
}
.listRight {
  display: flex;
  /* width: 20%; */
  justify-content: flex-end;
  color: rgb(255, 255, 255);
}
.formData {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
}
.conent_werp {
  width: 100%;
  height: 100%;
  display: flex;
  /* overflow: auto; */
}
.left {
  width: 237px;
  height: 100%;
  /* border: 1px solid red; */
  overflow: auto;
  position: relative;
}
.titles {
  background: #5cb6d9;
  width: 100%;
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  height: 30px;
  overflow: hidden;
  /* text-align: center; */
}
.ceonetns {
  /* flex: 1; */
  width: 100%;
  /* height: 200px; */
  height: calc(100vh - 100px);
  overflow: auto;
}
.leeft {
  display: flex;
  flex-wrap: wrap;
}
.heneds {
  /* height: 100%; */
  overflow: auto;
}
.ovst {
  overflow: auto;
}
.zhe {
  padding: 7px 0;
  /* margin-top: 30px; */
}
.addcentent {
  display: flex;
  justify-content: center;
}
.fletnFedn {
  position: absolute;
  /* color: red; */
  left: -5px;
  top: -5px;
}
.fleCt {
  position: absolute;
  /* color: red; */
  left: -2px;
  top: -2px;
}
/* .fletnFedn img{
  width: 50px;
} */
.warp {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;

  /* height: 500px; */
}
.netColor {
  display: flex;
  align-items: center;
  padding: 0 5px 0 5px;
}
.colorEnd {
  width: 30px;
  height: 22px;
  background: red;
  border-radius: 5px;
}
.wd {
  width: 10%;
  /* border: 1px solid red; */
  text-align: center;
  /* padding: 10px 0; */
  margin: 10px 6px 0px 6px;
  border-radius: 10px;
  /* height: 79px; */
}
.red {
  /* border: 1px solid red; */
  color: #fff;
  /* background: #ff5353; */
  background-image: url("../../assets/img/geer.png");
  background-size: cover;
  border-radius: 10px;
  /* padding: 10px 0; */
  /* background-image: linear-gradient(#FF0000, #FF9595); */
}
/* 上线 */
.greed {
  /* border: 1px solid #0a8e12; */
  color: #ffff;
  /* background: #00c600; */
  background-image: url("../../assets/img/green.png");
  background-size: cover;
  border-radius: 10px;
  /* padding: 10px 0; */
  /* background-image: linear-gradient(#008000, #00ff80); */
}
.bult {
  /* border: 1px solid #409eff; */
  color: #fff;
  /* background: #0080ff; */
  background-image: url("../../assets/img/blue.png");
  background-size: cover;
  border-radius: 10px;
  /* padding: 10px 0; */
  /* background-image: linear-gradient(#0000FF, #9999FF); */

  /* height: 93px; */
}
/* 系统故障 */
.geeds {
  color: #fff;
  /* background: #0080ff; */
  /* background-image: url("../../assets/img/violet.png"); */
  background-image: url("../../assets/img/brown.png");
  background-size: cover;
  border-radius: 10px;
}
.newWifx {
  margin: 0 5px;
  /* width: 20px;
  height: 20px; */
}
.boax_warp {
  display: flex;
  justify-content: space-between;
  /* height: 100%; */
  align-items: center;
}
.nelIGmgs {
  display: flex;
  align-items: center;
  /* margin-right:10px ; */
  width: 30px;
}
.warp_left {
  width: 50%;
  font-weight: bold;
}
.warp_rigth {
  width: 50%;
  /* float: right; */
  text-align: right;
  margin-right: 5px;
  font-weight: bold;
  /* color: yellow; */
}
.font-Sis {
  font-size: 26px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40%;
  /* color: yellow; */
}
.doap_warp {
  text-align: center;
  height: 150px;
  line-height: 150px;
  font-size: 22px;
}

.titlesImgs {
  display: flex;
  /* align-items: center; */
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  /* color: yellow; */
  position: relative;
  /* height: 50%; */
}
.rightIcom {
  position: absolute;
  right: 15px;
  cursor: pointer;
}
/* .treePostiron{
  position: relative;
} */
.newimgList_Warp {
  position: absolute;
  left: 0;
  top: 50%;
}
</style>
